import {Current} from "./current";

class MoneyFormatter {
  constructor(currency = 'USD', {symbol = '$', divide = true, divisor, round = true } = {}) {
    this.options = {
      style: 'currency',
      currency: currency || 'USD',
      minimumFractionDigits: 0, // Set minimumFractionDigits to 0 to remove trailing zeros
    }

    this.symbol = symbol
    this.divide = divide
    this.divisor = divisor
    this.round = round
  }

  // Returns a formatted amount that acts like humanized_money_with_symbol on the server
  humanizeWithSymbol(cents) {
    const formattedAmount = this.formatter
      .formatToParts(this.formatAmount(cents))
      .reduce((acc, part) => {
        if (part.type !== 'currency') {
          return acc + part.value;
        }
        return acc;
      }, '').trim()


    return `${this.symbol}${formattedAmount} ${this.options.currency}`
  }

  humanizeWithSymbolAndWithoutCurrencyCode(cents) {
    const formattedAmountWithoutCurrency = this.formatter
      .formatToParts(this.formatAmount(cents))
      .reduce((acc, part) => {
        if (part.type !== 'currency') {
          return acc + part.value;
        }
        return acc;
      }, '').trim()

    return `${this.symbol}${formattedAmountWithoutCurrency}`
  }

  transformer({value, currency}) {
    return Number(value).toLocaleString(Current.locale, {
      ...this.options,
      style: 'currency',
      currency: currency.code,
    });
  };

  formatAmount(value) {
    const amount = this.divide ? value / this.divisor : value

    if (this.round) {
      return Math.round(amount)
    }

    return amount
  }

  get formatter() {
    return new Intl.NumberFormat(Current.locale, this.options);
  }
}

export {MoneyFormatter}
